import { render } from "./ProgramView.vue?vue&type=template&id=81f19eee&scoped=true"
const script = {}

import "./ProgramView.vue?vue&type=style&index=0&id=81f19eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f19eee"]])

export default __exports__